import { TYC } from 'constants/api'
import useAxios from 'axios-hooks'
import useMainClass from 'hooks/use-main-cass'
import LoadingScreen from 'components/loading-screen'
import styled from 'styled-components'
import { Type } from 'theme/types'
import useRouter from 'hooks/use-router'
import Breadcrumb from 'components/breadcrumb'
import { Helmet } from 'react-helmet'
import styles from './styles.module.scss'

const Div = styled.div`
  ${({ theme }: Type) => theme?.termsAndConditions?.div}
`

const SEO_TITLE = 'Términos y condiciones | MyHeineken'
const SEO_DESCRIPTION = 'Consulta los términos y condiciones de MyHeineken México.'

const TYCPage = () => {
  useMainClass('terms-and-conditions')
  const { push } = useRouter()
  const [{ loading, error, data }] = useAxios({
    url: TYC,
    headers: { 'Ph-Api-Id': PH_API_ID??1 }
  })

  if (error) {
    return (
      <div className='terms-container'>
        <Helmet>
          <title>{SEO_TITLE}</title>
          <meta name="description" content={SEO_DESCRIPTION} />
          <meta property="og:title" content={SEO_TITLE} />
          <meta property="og:description" content={SEO_DESCRIPTION} />
          <meta name="robots" content="noindex,follow" />
        </Helmet>
        <div className='w-full pt-3'>
          <Breadcrumb
            text='Términos y condiciones de uso'
            handleClick={() => push('/home')}
          />
        </div>
        <Div className={`${styles.wrapper} container-terms`}>
          <h1 className="text-center text-5xl font-bold uppercase">Términos y condiciones</h1>
          <p data-nosnippet="true" className="text-center pt-5">
            No pudimos cargar el contenido en este momento.
          </p>
        </Div>
      </div>
    )
  }

  if (loading) {
    return (
      <>
        <Helmet>
          <title>{SEO_TITLE}</title>
          <meta name="description" content={SEO_DESCRIPTION} />
          <meta property="og:title" content={SEO_TITLE} />
          <meta property="og:description" content={SEO_DESCRIPTION} />
        </Helmet>
        <LoadingScreen />
      </>
    )
  }

  if (data) {
    return (
      <div className='terms-container'>
        <Helmet>
          <title>{SEO_TITLE}</title>
          <meta name="description" content={SEO_DESCRIPTION} />
          <meta property="og:title" content={SEO_TITLE} />
          <meta property="og:description" content={SEO_DESCRIPTION} />
        </Helmet>
        <div className='w-full pt-3'>
          <Breadcrumb 
            text='Términos y condiciones de uso'
            handleClick={() => push('/home')}
          />
        </div>
        <Div className={`${styles.wrapper} container-terms`}>
          <div dangerouslySetInnerHTML={{ __html: data }}></div>
        </Div>
      </div>
    )
  }

  return (
    <div className='terms-container'>
      <Helmet>
        <title>{SEO_TITLE}</title>
        <meta name="description" content={SEO_DESCRIPTION} />
        <meta property="og:title" content={SEO_TITLE} />
        <meta property="og:description" content={SEO_DESCRIPTION} />
      </Helmet>
      <div className='w-full pt-3'>
        <Breadcrumb 
          text='Términos y condiciones de uso'
          handleClick={() => push('/home')}
        />
      </div>
      <p className='terms-not-found text-center pt-5' data-nosnippet="true">Not found</p>
    </div>
  )
}

export default TYCPage
